(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dzule-product-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-dzr-section]').forEach((section)=>{if(section.dataset.ready)return;section.dataset.ready='true';const reviews=JSON.parse(section.querySelector('[data-dzr-json]').textContent);const list=section.querySelector('[data-dzr-list]');const count=section.querySelector('[data-dzr-count]');const modal=section.querySelector('[data-dzr-modal]');const modalImage=modal.querySelector('[data-dzr-modal-image]');count.textContent='30-97 avaliações';const initials=(name)=>name.split(' ').map(x=>x[0]).slice(0,2).join('');const escapeHtml=(value)=>String(value).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'",'&#039;');const render=(filter='all')=>{list.innerHTML=reviews.filter(review=>filter==='all'||(filter==='photo'&&review.photos.length)||(filter==='no-photo'&&!review.photos.length)).map(review=>`<article class="dzr__review"><div class="dzr__author">${review.profile?`<img class="dzr__avatar" src="${escapeHtml(review.profile)}" alt="Foto de perfil de ${escapeHtml(review.name)}" width="104" height="104" loading="lazy">`:`<span class="dzr__avatar dzr__initials">${initials(review.name)}</span>`}<div><div class="dzr__name">${escapeHtml(review.name)}</div>${review.verified?'<div class="dzr__verified">✓ Verificado</div>':''}</div></div><div><div class="dzr__stars" aria-label="${review.stars} de 5 estrelas">${'★'.repeat(review.stars)}${'☆'.repeat(5-review.stars)}</div><p class="dzr__comment">${escapeHtml(review.comment)}</p>${review.photos.length?`<div class="dzr__media">${review.photos.map(photo=>`<button class="dzr__photo" type="button" data-dzr-photo="${escapeHtml(photo)}" aria-label="Ampliar foto da avaliação"><img src="${escapeHtml(photo)}" alt="Foto publicada na avaliação" width="420" height="500" loading="lazy"></button>`).join('')}</div>`:''}</div></article>`).join('')};section.querySelectorAll('[data-dzr-filter]').forEach(button=>button.addEventListener('click',()=>{section.querySelectorAll('[data-dzr-filter]').forEach(x=>x.classList.remove('is-active'));button.classList.add('is-active');render(button.dataset.dzrFilter)}));list.addEventListener('click',event=>{const button=event.target.closest('[data-dzr-photo]');if(!button)return;modalImage.src=button.dataset.dzrPhoto;modalImage.style.setProperty('--dzr-zoom',1);modal.showModal()});modal.querySelector('[data-dzr-close]').addEventListener('click',()=>modal.close());modal.addEventListener('click',event=>{if(event.target===modal)modal.close()});modalImage.addEventListener('wheel',event=>{event.preventDefault();const current=Number(modalImage.style.getPropertyValue('--dzr-zoom')||1);modalImage.style.setProperty('--dzr-zoom',Math.min(3,Math.max(1,current+(event.deltaY<0?.2:-.2))));modalImage.style.setProperty('--dzr-x',event.offsetX/modalImage.clientWidth*100+'%');modalImage.style.setProperty('--dzr-y',event.offsetY/modalImage.clientHeight*100+'%')},{passive:false});render()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
